<!-- 
mp3
 -->
<template>
  <div class="mp3-main">
    <audio :src="audio.sourceUrl" id="mymp3" ref="mymp3">
      Your browser does not support the audio element.
    </audio>
    <div class="main-body">
      <!-- <div class="top-img">
          <img :src="img" alt="">
        </div> -->
      <div class="coverimg">
        <!-- <img :src="img2" alt=""> -->
        <van-image
          round
          width="6rem"
          height="6rem"
          :src="bakimgsrc"
          fit="cover"
        />
      </div>
      <div class="listen">
        <!-- <a-avatar  icon="home" /> -->
        <div class="listen-bac">
          <a-icon type="customer-service" style="color: #fff" />
        </div>
      </div>
      <div class="title">
        <p class="content-title">{{ view.title }}</p>
        <div class="content-data">
          <span class="content-time">{{
            view.displayDate.substring(0, 10)
          }}</span>
          <a-icon
            type="customer-service"
            style="color: #fff"
            class="content-i"
          />
          <span>{{ view.count.readCount }}</span>
        </div>
      </div>
      <div class="progress">
        <p class="progress-text">{{ cTime }}</p>
        <div class="progress-bar">
          <a-slider
            v-model="time"
            @change="onChange"
            @afterChange="onAfterChange"
            :max="max"
            :tipFormatter="tipFormatter"
            v-if="done"
          />
          <a-slider v-else />
        </div>
        <p class="progress-text">{{ dTime }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mp3body",
  props: {
    view: {
      type: Object,
    },
    audio: {
      type: Object,
    },
  },
  data() {
    return {
      max: null, // 进度条最大时长
      dTime: "00:00", // 音频当前时间
      cTime: "00:00", // 音频最大时长
      done: false, // 加载完毕
      time: 0, // 进度条当前时间
      music: null, // MP3实例
      isPaused: true, // 当前音频是否播放
      bakimgsrc: this.audio.thumbUrl,
      img: require("@/assets/images/mhst.png"),
      img2: require("@/assets/images/test.jpg"),
      canplayFlag: false,
      wechatIos: false,
      duration: 0,
    };
  },
  watch: {
    audio: {
      handler(newVal, oldVale) {
        console.log(oldVale, "oldVale");
        this.audio = newVal;
        this.initPlay();
      },
      deep: true, // 深度监听
    },
  },
  mounted() {
    this.initPlay();
  },
  methods: {
    initPlay() {
      this.bakimgsrc = this.audio.thumbUrl;
      this.duration = this.audio?.duration;
      const music = this.$refs.mymp3; // 音频所在对象
      music.addEventListener("canplay", () => {
        this.canplayFlag = true;
        this.onLoadMusic(music);
      });
      if (!this.canplayFlag) {
        this.onLoadMusic(music);
      }

      music.addEventListener("timeupdate", () => {
        this.time = music.currentTime;
        const branch = Math.floor(this.time / 60); // 计算已播放的音频分钟
        const second = Math.floor(this.time % 60); // 计算已播放的音频秒
        if (branch < 10 && second < 10) {
          // 四种情况判断显示音频以播放时间
          this.cTime = `0${branch}:0${second}`;
        } else if (branch < 10) {
          this.cTime = `0${branch}:${second}`;
        } else if (second < 10) {
          this.cTime = `${branch}:0${second}`;
        } else {
          this.cTime = `${branch}:${second}`;
        }
        if (music.currentTime == music.duration) {
          this.isPaused = true;
          this.$emit("stateChange", this.isPaused);
        }
      });
    },
    // duration 的值可以在 canplay 事件发生之前的 durationchange 阶段中获取
    // 解决ios获取时间NAV问题
    durationchange(music) {
      return new Promise((resolve) => {
        // if (this.wechatIos) {
        //   music.addEventListener("onloadedmetadata", () => {
        //       musicTime = music.duration;
        //       resolve(musicTime);
        //     });
        // } else {
        //   music.addEventListener("durationchange", () => {
        //     musicTime = music.duration;
        //     resolve(musicTime);
        //   });
        // }

        music.ondurationchange = function() {
          const musicTime = music.duration;
          resolve(musicTime);
        };
      });
    },
    async onLoadMusic(music) {
      let musicTime = this.duration
        ? Math.ceil(this.duration / 1000)
        : await this.durationchange(music); // 获得音频时长
      const branch = Math.floor(musicTime / 60); // 计算音频分钟
      const second = Math.ceil(musicTime % 60); // 计算音频秒
      if (branch < 10 && second < 10) {
        // 四种情况判断音频总时间
        this.dTime = `0${branch}:0${second}`;
      } else if (branch < 10) {
        this.dTime = `0${branch}:${second}`;
      } else if (second < 10) {
        this.dTime = `${branch}:0${second}`;
      } else {
        this.dTime = `${branch}:${second}`;
      }

      this.max = musicTime;
      this.done = true;
      this.music = music;
      this.play();
    },
    onChange(e) {
      this.music.currentTime = e;
      console.log(e);
    },
    onAfterChange(e) {
      console.log(e);
    },
    play() {
      if (!this.music) return;
      this.music.play();
      this.isPaused = this.music.paused;
      this.$emit("stateChange", this.isPaused);
    },
    pause() {
      if (!this.music) return;
      this.music.pause();
      this.isPaused = this.music.paused;
      this.$emit("stateChange", this.isPaused);
    },
    next(e) {
      this.pause();
      this.music.src = "";
      this.music.src = e;
      this.play();
    },
    setBakImgSrc(url) {
      this.bakimgsrc = url;
    },
    tipFormatter(e) {
      const min = parseInt(e / 60);
      const sec = e % 60;
      const topStr = min.toString() + ":" + sec.toString();
      return topStr;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-slider-handle {
  border: 0;
}
.mp3-main {
  background-color: #242a38;
  .main-body {
    .top-img {
      max-width: 120px;
      margin: 0 auto;
    }
    .coverimg {
      display: flex;
      justify-content: center;
      margin: 20px 0;
    }
    .listen {
      display: flex;
      justify-content: center;
      margin-top: -50px;
      .listen-bac {
        z-index: 999;
        background: #1890ff;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .title {
      margin: 20px 0;
      text-align: center;
      .content-title {
        color: #fff;
        font-size: 22px;
        margin-bottom: 0;
      }
      .content-data {
        display: flex;
        justify-content: center;
        font-size: 14px;
        color: #d9d9d9;
        .content-time {
          margin-right: 20px;
        }
        .content-i {
          display: flex;
          align-items: center;
        }
        span {
          padding-left: 3px;
        }
      }
    }
  }
}
.progress {
  display: flex;
  .progress-text {
    font-size: 16px;
    margin: auto 15px;
    color: white;
  }
  .progress-bar {
    width: 100%;
  }
}
</style>
